var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmoke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0034 14.2714C16.5223 15.9397 13.6971 19.6148 12.8609 23.5624C12.6205 24.6968 12.5991 26.6997 12.8157 27.7748C13.3803 30.5771 14.919 32.7915 17.4351 34.4224C18.2879 34.9752 18.9625 35.3119 21.0775 36.2402C25.9693 38.3873 27.6326 39.5954 28.5945 41.6999C29.308 43.2608 29.3848 45.1568 28.8292 47.4976C28.7151 47.9782 28.6049 48.5041 28.5842 48.6664C28.496 49.3572 28.9611 49.9265 29.6664 49.9911C30.0069 50.0223 30.1083 49.9864 30.717 49.6184C33.8137 47.747 35.8845 44.9769 36.4965 41.8872C36.6575 41.0744 36.6398 39.0934 36.4642 38.2695C36.0091 36.1346 35.0021 34.3069 33.3254 32.5722C31.9937 31.1943 31.0049 30.487 28.4422 29.0791C25.6932 27.5689 24.5324 26.774 23.3589 25.5982C22.8966 25.135 22.3967 24.5487 22.2481 24.2951C21.2243 22.5495 21.0957 20.3207 21.799 16.5124C21.9085 15.9198 21.9981 15.2951 21.9981 15.1241C21.9981 14.5452 21.4286 13.9895 20.8351 13.9893C20.7017 13.9892 20.3275 14.1161 20.0034 14.2714Z",
    fill: "url(#paint0_linear_5150_3864)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4322 10.2423C31.6307 11.5759 29.352 14.5239 28.6715 17.6951C28.476 18.6064 28.4545 20.2162 28.6263 21.0809C29.0742 23.3345 30.3063 25.1176 32.3252 26.4338C33.0095 26.8799 33.551 27.152 35.249 27.9026C39.1764 29.6388 40.5108 30.6133 41.2795 32.3069C41.8497 33.5631 41.9074 35.0872 41.4559 36.9675C41.3632 37.3535 41.2735 37.776 41.2565 37.9064C41.1841 38.4615 41.5568 38.9201 42.1236 38.9735C42.3972 38.9993 42.4788 38.9706 42.9688 38.6762C45.4619 37.1785 47.1322 34.9563 47.6306 32.4742C47.7617 31.8212 47.7517 30.2289 47.6123 29.5663C47.251 27.8493 46.4455 26.3781 45.1015 24.9803C44.0339 23.87 43.2407 23.2993 41.1838 22.1623C38.9774 20.9426 38.0461 20.3012 37.1054 19.3537C36.7348 18.9804 36.3342 18.508 36.2152 18.3039C35.396 16.8986 35.2974 15.1069 35.8708 12.0474C35.96 11.5713 36.0333 11.0693 36.0337 10.9319C36.0349 10.4666 35.5783 10.0187 35.1013 10.0173C34.9941 10.0169 34.693 10.1182 34.4322 10.2423Z",
    fill: "url(#paint1_linear_5150_3864)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5150_3864",
    x1: 24.6366,
    y1: 13.9893,
    x2: 24.6366,
    y2: 49.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7BB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65C8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5150_3864",
    x1: 38.1569,
    y1: 10.0253,
    x2: 38.0807,
    y2: 38.9699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7BB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65C8FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmoke);
export default __webpack_public_path__ + "static/media/smoke.7fe1bce78bb0a4ff548129c8eed333d3.svg";
export { ForwardRef as ReactComponent };